import { makeAutoObservable } from "mobx";
import { AppStore } from "store/App.store";
import { AccountJupixApi } from "api/account-jupix.api";
import { AccountIntegrationOfficesStore } from "../AccountIntegrationOfficesStore.store";

const accountJupixApi = new AccountJupixApi();

export class AccountIntegrationJupixStore {
  public accountIntegrationJupixOfficesStore: AccountIntegrationOfficesStore;
  public accountId: number;

  constructor(root: AppStore, accountId: number) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.accountIntegrationJupixOfficesStore = new AccountIntegrationOfficesStore(
      root,
      accountId,
      accountJupixApi
    );
    this.accountId = accountId;
  }
}
